import { getObjectUtil } from 'packages/src'
import { createPlanAction } from '../create'
import updateCurrentPlanAction from '../set-current'
import updateDataPlanAction from '../update-data'
import PLANS_ACTION from '../../constants/action'
import PLANS_DOMAIN from '../../constants/domain'
import PLANS_ENDPOINT from '../../constants/endpoint'
import getCurrentPlanSelect from '../../selectors/get-current'
import getLocalStartAtPlanSelect from '../../selectors/get-local-start-at'
import saveReduxAction from '../../../redux/actions/save'
import { MODEL_KEY } from '../../../../modules/model/constants'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getInstanceReduxUtil from '../../../redux/utils/get-instance'
import { getPathReduxUtil } from '../../../redux/utils/get-path'
import getPathFromDomainPathReduxUtil from '../../../redux/utils/get-path-from-domain-path'

function clonePlanAction (params = {}) {
  return async (dispatch, getState) => {
    let currentPlan = params.plan || getCurrentPlanSelect(getState())
    currentPlan = getInstanceReduxUtil(getState(), currentPlan)
    if (!currentPlan) {
      return
    }

    const currentPlanId = getIdReduxUtil(currentPlan)
    let plan = dispatch(createPlanAction())
    const response = await dispatch(saveReduxAction({
      type: PLANS_ACTION.COPY,
      payload: {
        endpoint: PLANS_ENDPOINT.COPY,
        path: getPathReduxUtil(plan),
        data: {
          id: currentPlanId,
          startAt: getLocalStartAtPlanSelect(getState())
        }
      }
    }))
    const planId = getObjectUtil(response, `data.plan.${MODEL_KEY.ID}`)
    plan = getObjectUtil(getState(), getPathFromDomainPathReduxUtil(PLANS_DOMAIN, planId))
    dispatch(updateCurrentPlanAction(plan))
    dispatch(updateDataPlanAction(plan))
    return plan

    // // Add a reference to the `parentId` so it gets updated once it gets
    // saved const parentPlan = getByIdPlanSelector(parentId)(getState()) if
    // (parentPlan) { dispatch( addReferenceAction({ instance: parentPlan,
    // referencePath:
    // `${getPathReduxUtil(newPlan)}.changed.${PLAN_KEY.PARENT_ID}` }) ) } //
    // Add a reference to the `originalParentId` so it gets updated once it
    // gets saved const originalParentPlan =
    // getByIdPlanSelector(parentId)(getState()) if (originalParentPlan) {
    // dispatch( addReferenceAction({ instance: originalParentPlan,
    // referencePath:
    // `${getPathReduxUtil(newPlan)}.changed.${PLAN_KEY.ORIGINAL_PARENT_ID}` }) ) }  return getInstanceReduxUtil(getState(), newPlan)
  }
}

export default clonePlanAction
